export const lightheme = {
  colors: {
    navbarBgColor: "#35404F",
    mainColor: "#E45F56",
    logoColor: "#8B7E74",
    linkColor: "#8B7E74",
    detailBgColor: "rgb(225, 241, 221,0.4)",
    detailColor: "#35404F",
    linkHoverColor: "#E45F56",
    headerFormColor: "rgb(53, 64, 79,0.5)",
  },
  screens: {
    lg: "992px",
  },
};
export const darktheme = {
  colors: {
    navbarBgColor: "rgba(255, 255, 255, 0.46)",
    mainColor: "rgb(15,15,15)",
    logoColor: "rgb(5,5,5)",
    linkColor: "rgb(5,5,5)",
    detailBgColor: "rgb(15,15,15)",
    detailColor: "white",
    linkHoverColor: "bisque",
    headerFormColor: "rgba(255, 255, 255, 0.46)",
  },
  screens: {
    lg: "992px",
  },
};
